import React from "react";
import DoubleLine from "./DoubleLine";

const koulen = { fontFamily: "Koulen, sans-serif" };

// One month's heading, approved-hours subtotal and -- for pages whose rows are
// a single line -- column labels. Pages with two-line rows omit `columns` and
// get a plain rule instead. `gridClass` must be a literal Tailwind class:
// classes built by interpolation are not scanned. Its track count must match
// `columns`.
export default function MonthSection({ label, approvedHours, gridClass, columns, children }) {
    return (
        <section className="mt-[80px]">
            <DoubleLine />
            <div className="mt-[12px] flex flex-wrap items-baseline justify-between gap-x-6">
                <h2
                    className="text-[44px] sm:text-[64px] leading-normal text-[#1c2938] tracking-[3.2px]"
                    style={koulen}
                >
                    {label}
                </h2>
                {approvedHours > 0 && (
                    <p
                        className="text-[24px] sm:text-[32px] text-[#6e4e37] tracking-[1.6px]"
                        style={koulen}
                    >
                        {approvedHours} HRS APPROVED
                    </p>
                )}
            </div>
            {columns ? (
                /* Column labels -- hidden on mobile where rows stack */
                <div
                    className={`mt-[24px] hidden sm:grid ${gridClass} gap-x-4 pb-[9px] border-b border-[#1c2938] text-[16px] text-[#777f88] tracking-[0.8px]`}
                >
                    {columns.map((column, i) => (
                        <span key={column || `spacer-${i}`}>{column}</span>
                    ))}
                </div>
            ) : (
                <div className="mt-[24px] border-b border-[#1c2938]" />
            )}
            {children}
        </section>
    );
}
